import { atom, createStore } from "jotai";
import { steps } from "../steps";

export type OnboardingStepKey =
  | "team"
  | "company-profile"
  | "integrations"
  | "customers"
  | "sample-data"
  | "channels"
  | "billing-settings"
  | "ready";

export const onboardingStore = createStore();

export interface Step {
  key: string;
  title: string;
  estimatedTime: string;
  rightBg:
    | string
    | {
        email: string;
        desktop: string;
        mobile: string;
        // android: string;
        // ios: string;
        teams: string;
      };
}
export interface SampleDataPayload {
  ticket?: boolean;
  project?: boolean;
}

export const currentStepAtom = atom<Step>(steps[0]);
export const channelTabAtom = atom<
  | "email"
  | "desktop"
  | "mobile"
  // | "android" | "ios"
  | "teams"
>("email");
export const dynamicRightBgAtom = atom((get) => {
  const currentStep = get(currentStepAtom);
  const channelTab = get(channelTabAtom);
  if (typeof currentStep.rightBg === "string") {
    return currentStep?.rightBg;
  }
  return currentStep?.rightBg?.[channelTab];
});
export const sampleDataAtom = atom<SampleDataPayload>({});
export const hideSkipButtonStepsAtom = atom<string[]>([]);

export const currentStepObj = atom((get) => get(currentStepAtom));
export const channelTab = atom((get) => get(channelTabAtom));
export const sampleDataObj = atom((get) => get(sampleDataAtom));
export const hideSkipButtonStepsArr = atom((get) =>
  get(hideSkipButtonStepsAtom)
);

export const setCurrentStepFn = atom(null, (get, set, value: Step) => {
  set(currentStepAtom, value);
});
export const setSampleDataFn = atom(
  null,
  (get, set, value: SampleDataPayload) => {
    set(sampleDataAtom, value);
  }
);
export const setHideSkipButtonStepsFn = atom(
  null,
  (get, set, value: string[]) => {
    set(hideSkipButtonStepsAtom, value);
  }
);
